import { render, staticRenderFns } from "./PrestadorAutocomplete.vue?vue&type=template&id=f3450028"
import script from "./PrestadorAutocomplete.vue?vue&type=script&lang=js"
export * from "./PrestadorAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports